

export enum DIALOG_TYPE {
  Address = 'address',
  SingleText = 'singleText',
  GroupFields = 'groupFields',
  SingleSelect = 'singleSelect',
  MultiSelect = 'multiSelect',
  Deactivate = 'deactivate',
  Delete = 'delete',
  Confirm = 'confirm',
  InviteUser = 'inviteUser',
  Grid = 'grid',
  uploadStatus = 'uploadStatus',
}
